"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _config = _interopRequireDefault(require("../../../../targets/cord_sanofi/config.js"));

var _ChatInput = _interopRequireDefault(require("./ChatInput.scss"));

var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _Picker = _interopRequireDefault(require("../EmojiPicker/Picker"));

function ChatInput(_ref) {
  var sendMessageFn = _ref.sendMessageFn,
      quotedMessage = _ref.quotedMessage,
      resetQuotedMessage = _ref.resetQuotedMessage;

  var _useState = (0, _react.useState)(''),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      currentText = _useState2[0],
      setCurrentText = _useState2[1];

  var _useState3 = (0, _react.useState)(null),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      quote = _useState4[0],
      setQuote = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      showEmojiPicker = _useState6[0],
      setShowEmojiPicker = _useState6[1];

  var textfieldRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    if (_config["default"].allowEnterAsSendInChat) {
      textfieldRef.current.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          sendMessage();
        }
      });
    }
  }, []);

  function sendMessage() {
    if (currentText.length > 0) {
      sendMessageFn(currentText);
      setCurrentText('');
      setQuote(null);
      textfieldRef.current.parentNode.style.height = '100px';
    }
  }

  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatInput["default"].chatInput
  }, quotedMessage ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatInput["default"].quote
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatInput["default"].quoteTitle
  }, 'Zitat:'), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatInput["default"].name
  }, quotedMessage.userName, ":"), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatInput["default"].text,
    dangerouslySetInnerHTML: {
      __html: quotedMessage.text.replace(/(\r\n|\n|\r)/gm, '<br />')
    }
  }), /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    className: _ChatInput["default"].removeQuoteButton,
    onClick: function onClick() {
      resetQuotedMessage();
    },
    name: "times"
  })) : null, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
    ref: textfieldRef,
    className: _ChatInput["default"].textfield,
    InputProps: {
      disableUnderline: true,
      className: _ChatInput["default"].textfieldLabel
    },
    autoComplete: "on",
    autoCorrect: "on",
    autoCapitalize: "on",
    spellCheck: "true",
    multiline: true,
    onChange: function onChange(evt) {
      return setCurrentText(evt.target.value);
    },
    type: 'text',
    placeholder: quote ? 'Gib hier deine Antwort ein' : 'Gib hier eine Nachricht ein',
    value: currentText
  }), /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    className: _ChatInput["default"].button,
    name: "paper-plane",
    onClick: sendMessage
  }), /*#__PURE__*/_react["default"].createElement(_reactFontawesome["default"], {
    className: _ChatInput["default"].emojiButton,
    onClick: function onClick() {
      return setShowEmojiPicker(!showEmojiPicker);
    },
    name: "smile-o"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _ChatInput["default"].picker,
    style: showEmojiPicker ? {
      maxHeight: '1000px'
    } : {
      maxHeight: 0
    }
  }, /*#__PURE__*/_react["default"].createElement(_Picker["default"], {
    onEmojiSelected: function onEmojiSelected(emoji) {
      return setCurrentText(currentText + emoji);
    },
    closeFn: function closeFn() {
      return setShowEmojiPicker(false);
    }
  })));
}

ChatInput.propTypes = {
  sendMessageFn: _propTypes["default"].func.isRequired,
  quotedMessage: _propTypes["default"].object,
  resetQuotedMessage: _propTypes["default"].func
};
var _default = ChatInput;
exports["default"] = _default;